/**
 * env × domain → URL/headers 매핑 테이블.
 *
 * core-ui 가 비즈니스 endpoint 의 source of truth (Q4-A 정책).
 * endpoint 변경 시 이 파일만 수정 + semver 결정 (URL 변경은 patch, response shape 변경은 minor/major).
 *
 * @see plan/category-widget-design.md — Q4, Q20, 외부 의존성 D1-D2
 *
 * ⚠️ PLACEHOLDER — 인프라/백엔드 팀의 공중망 endpoint URL 확정 시 교체.
 * 현재 값은 cx-display-api 의 추정 도메인 패턴이며 실제 host 와 다를 수 있음.
 */

import type { DomainKey, Env } from './types';

export interface EndpointConfig {
  url: string;
  /** 추가 헤더. credentials (cookie) 는 fetch 의 `credentials: 'include'` 로 처리. */
  headers?: Record<string, string>;
}

/**
 * 도메인별 env-URL 매핑.
 *
 * **partial 타입 이유**: `cart` 같이 host fetcher override 가 필수인 도메인은 url-table 에 등록 안 함.
 * `resolveEndpoint` 가 미등록 도메인에 대해 `undefined` 를 반환하면 Provider 가 *host fetcher 미주입*
 * error entry 를 생성 (fetchers.cart 가 있으면 그것 사용, 없으면 dev warn).
 */
type UrlTable = Partial<Record<DomainKey, Record<Env, EndpointConfig>>>;

/**
 * env 별 endpoint host. PLACEHOLDER.
 *
 * `Nol-Platform` 헤더는 Provider 가 fetch 시점에 자동 합성 — 호스트의 `platform` prop 으로부터.
 * url-table 에는 *도메인별 고유 헤더* 만 정의 (현재는 없음).
 */
export const URL_TABLE: UrlTable = {
  category: {
    local: { url: 'https://fe-display-api.dev.yanolja.in/gnb/v1/category-overview' },
    dev: { url: 'https://fe-display-api.dev.yanolja.in/gnb/v1/category-overview' },
    qa: { url: 'https://fe-display-api.qa.yanolja.in/gnb/v1/category-overview' },
    stage: { url: 'https://fe-display-api.stage.yanolja.in/gnb/v1/category-overview' },
    prod: { url: 'https://fe-display-api.yanolja.com/gnb/v1/category-overview' },
  },
  bi: {
    local: { url: 'https://fe-display-api.dev.yanolja.in/gnb/v1/bi' },
    dev: { url: 'https://fe-display-api.dev.yanolja.in/gnb/v1/bi' },
    qa: { url: 'https://fe-display-api.qa.yanolja.in/gnb/v1/bi' },
    stage: { url: 'https://fe-display-api.stage.yanolja.in/gnb/v1/bi' },
    prod: { url: 'https://fe-display-api.yanolja.com/gnb/v1/bi' },
  },
};

export const resolveEndpoint = (key: DomainKey, env: Env): EndpointConfig | undefined => URL_TABLE[key]?.[env];
